<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-snackbar v-model="snackbar" :color="snackColor" right bottom :timeout="4000">
        {{ snackText }}
        <template #action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialogEnviandoComp" persistent width="300">
        <v-card color="primary" dark class="pt-5 pb-2">
          <v-card-text style="color: white">
            Enviando comprobante
            <v-progress-linear indeterminate color="white" class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG CREAR / EDITAR -->
      <v-dialog v-model="dialogFoto" persistent max-width="600px">
        <v-form ref="formFoto" v-model="validFoto" lazy-validation>
          <v-card>
            <v-card-text class="text--primary" style="margin-top: -20px">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <span class="text-h5 font-weight-medium">{{ formTitle }}</span>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <v-text-field
                      v-model="descripcion"
                      :rules="descripcionRules"
                      color="primary"
                      label="Descripción"
                      :readonly="completada"
                    />
                  </v-flex>

                  <v-flex xs12 class="font-weight-medium">
                    <span v-if="editedIndex === 1">
                      Usted ya adjuntó una foto, si desea sustituirla puede seleccionar un nuevo archivo.
                      De lo contrario, puede dejar este campo vacío.
                    </span>
                    <span v-else>Adjunte una foto de su vivienda</span>
                  </v-flex>

                  <v-flex xs12>
                    <v-file-input
                      v-model="archivoAdjunto"
                      color="primary"
                      :rules="editedIndex === 1 ? [] : adjuntosRules"
                      label="Archivo adjunto"
                      placeholder="Selecciona tu archivo"
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg, image/bmp"
                      outlined
                      counter
                      :show-size="1000"
                      :disabled="completada"
                    >
                      <template #selection="{ text }">
                        <v-chip color="primary" dark label small>
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions style="margin-top: -40px; margin-right: 20px; padding-bottom: 20px;">
              <v-spacer />
              <v-btn color="primary" text @click.native="close">Cancelar</v-btn>
              <v-btn
                color="primary white--text"
                :disabled="!validFoto || completada"
                @click.native="saveFoto"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <!-- DIALOG ELIMINAR -->
      <v-dialog v-model="dialogEliminar" persistent max-width="600px">
        <v-form ref="formEliminar">
          <v-card>
            <v-card-text class="text--primary" style="margin-top: -20px">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <span class="text-h5 font-weight-medium">Remover foto</span>
                  </v-flex>

                  <v-flex xs12>
                    <span class="font-weight-regular" style="font-size: 20px">
                      ¿Está seguro que desea remover la foto?
                    </span>

                    <v-layout wrap style="margin-top: 10px">
                      <v-flex xs12>
                        <v-card
                          flat
                          color="red lighten-5"
                          class="text-center elevation-1"
                          style="border-radius: 10px; padding: 15px 25px;"
                        >
                          <span class="red--text text--darken-2 text-h6">{{ descripcion }}</span>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 text-center>
                    <v-icon color="primary" size="70" class="mt-2 mb-2">fa-trash-alt</v-icon>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions style="margin-top: -30px; padding-bottom: 20px">
              <v-spacer />
              <v-btn
                color="primary"
                dark
                outlined
                min-width="150"
                :disabled="completada"
                @click.native="removerFoto"
              >
                Si
              </v-btn>
              <v-btn color="primary" dark min-width="150" @click.native="close">No</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-card elevation="0">
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="font-weight: 500">Ingrese foto de su vivienda</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            class="mt-3"
            color="white"
            append-icon="fa-search"
            label="Búsqueda"
            single-line
          />

          <v-spacer />

          <v-tooltip bottom max-width="300" color="primary">
            <template #activator="{ on }">
              <v-btn
                text
                icon
                color="white darken-3"
                :disabled="completada || yaExisteFoto"
                v-on="on"
                @click="(completada || yaExisteFoto) ? false : nuevaFoto()"
              >
                <v-icon>fas fa-plus</v-icon>
              </v-btn>
            </template>
            <span style="font-size: 15px">{{ yaExisteFoto ? 'Ya existe una foto' : 'Agregar' }}</span>
          </v-tooltip>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="fotos"
          :search="search"
          :footer-props="{ itemsPerPageOptions: [10,25,50], itemsPerPageText: 'Filas por página:' }"
          no-data-text="Sin fotos"
          no-results-text="Búsqueda sin resultados"
          class="elevation-1"
        >
          <template #item.comprobantePath="{ item }">
            <v-tooltip right color="primary">
              <template #activator="{ on }">
                <v-icon color="primary" v-on="on" @click="visualizar(item)">fas fa-download</v-icon>
              </template>
              <span style="font-size: 15px">Clic para ver</span>
            </v-tooltip>
          </template>

          <template #item.opciones="{ item }">
            <v-tooltip bottom max-width="300" color="primary">
              <template #activator="{ on }">
                <v-btn
                  text
                  small
                  fab
                  color="amber darken-3"
                  :disabled="completada"
                  v-on="on"
                  @click="completada ? false : editItem(item)"
                >
                  <v-icon>fa-pen</v-icon>
                </v-btn>
              </template>
              <span style="font-size: 15px">Editar</span>
            </v-tooltip>

            <v-tooltip bottom max-width="300" color="primary">
              <template #activator="{ on }">
                <v-btn
                  text
                  small
                  fab
                  color="primary"
                  :disabled="completada"
                  v-on="on"
                  @click="completada ? false : deleteItem(item)"
                >
                  <v-icon>fa-trash-alt</v-icon>
                </v-btn>
              </template>
              <span style="font-size: 15px">Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FormBecaFotoVivienda',
  props: {
    solicitudBecaId: { type: Number, default: null },
    completada: { type: Boolean, default: false },
    // Vivienda en tu BD = 10
    egresoViviendaId: { type: Number, default: 10 }
  },
  data: () => ({
    // UI
    dialogFoto: false,
    dialogEliminar: false,
    dialogEnviandoComp: false,
    validFoto: true,
    snackbar: false,
    snackText: '',
    snackColor: 'primary',

    // Tabla
    search: '',
    headers: [
      { text: 'Descripción', value: 'descripcion', class: 'titulo' },
      { text: 'Comprobante', value: 'comprobantePath', class: 'titulo', sortable: false, align: 'center' },
      { text: 'Opciones', value: 'opciones', align: 'right', width: 120, sortable: false, class: 'titulo' }
    ],
    fotos: [],

    // Form
    editedIndex: -1,
    egresoIdRegistro: '',
    descripcion: 'Vivienda',
    archivoAdjunto: null,

    descripcionRules: [(v) => !!v || 'Ingrese una descripción'],
    adjuntosRules: [
      (file) => !!file || 'Seleccione un archivo.',
      (file) =>
        !file || ['image/png', 'image/jpeg', 'image/bmp'].includes(file.type) ||
        'Solo se permiten imágenes (PNG, JPG/JPEG, BMP).',
      (file) => !file || file.size <= 15000000 || 'Los archivos adjuntos no pueden pesar mas de 15MB!'
    ]
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nueva foto' : 'Editar foto'
    },
    yaExisteFoto() {
      return (this.fotos || []).length >= 1
    }
  },
  watch: {
    solicitudBecaId(val) {
      if (val != null) this.listarFotos()
    }
  },
  created() {
    if (this.solicitudBecaId != null) this.listarFotos()
  },
  methods: {
    listarFotos() {
      axios
        .get(`api/solicitudesdebecas/${this.solicitudBecaId}/SolicitudEgreso`)
        .then((response) => {
          const data = response.data || []
          this.fotos = data.filter((x) => Number(x.egresoId) === Number(this.egresoViviendaId))
        })
        .catch((error) => console.log(error))
    },

    nuevaFoto() {
      this.descripcion = 'Vivienda'
      this.openDialog()
    },

    editItem(item) {
      this.egresoIdRegistro = item.id
      this.descripcion = item.descripcion || 'Vivienda'
      this.editedIndex = 1
      this.openDialog()
      if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
    },

    deleteItem(item) {
      this.dialogEliminar = true
      this.egresoIdRegistro = item.id
      this.descripcion = item.descripcion || 'Vivienda'
      if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
    },

    saveFoto() {
      if (!this.$refs.formFoto.validate()) return

      this.dialogEnviandoComp = true
      const formData = new FormData()

      // Robustez: soporta File o Array<File>
      const file = Array.isArray(this.archivoAdjunto) ? this.archivoAdjunto[0] : this.archivoAdjunto
      if (file) {
        formData.append('files', file, file.name)
      }

      // CLAVE: mismo contrato que Egresos
      formData.append(
        'model',
        JSON.stringify({
          egresoId: this.egresoViviendaId,
          descripcion: this.descripcion,
          monto: 1
        })
      )

      const baseUrl = `api/solicitudesdebecas/${this.solicitudBecaId}/SolicitudEgreso`
      const req =
        this.editedIndex > -1
          ? axios.put(`${baseUrl}/${this.egresoIdRegistro}`, formData)
          : axios.post(baseUrl, formData)

      req
        .then(() => {
          this.close()
          this.snackText = this.editedIndex > -1 ? 'Foto editada exitosamente!' : 'Foto agregada exitosamente!'
          this.snackColor = 'snackSuccess'
          this.snackbar = true
          this.listarFotos()
          this.$emit('updated') // opcional, por si el padre quiere reaccionar
        })
        .catch((error) => {
          console.log(error)
          this.snackText = 'No se pudo subir la foto'
          this.snackColor = 'snackError'
          this.snackbar = true
          this.close()
        })
        .finally(() => {
          this.dialogEnviandoComp = false
        })
    },

    removerFoto() {
      axios
        .delete(`api/solicitudesdebecas/${this.solicitudBecaId}/SolicitudEgreso/${this.egresoIdRegistro}`)
        .then(() => {
          this.close()
          this.snackText = 'Foto eliminada exitosamente!'
          this.snackColor = 'snackSuccess'
          this.snackbar = true
          this.listarFotos()
          this.$emit('updated')
        })
        .catch((error) => console.log(error))
    },

    visualizar(item) {
      window.open(item.comprobantePath, null)
    },

    openDialog() {
      this.dialogFoto = true
    },

    close() {
      this.dialogFoto = false
      this.dialogEliminar = false
      this.clear()
      setTimeout(() => (this.editedIndex = -1), 300)
    },

    clear() {
      try {
        this.$refs.formFoto.resetValidation()
      } catch (e) {}
      this.egresoIdRegistro = ''
      this.descripcion = 'Vivienda'
      this.archivoAdjunto = null
    }
  }
}
</script>
